<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="860px" :destroy-on-close="true"
             :before-close="cancel">
    <mailing-content :select-detail="selectDetail"></mailing-content>
  </el-dialog>
</template>

<script>
import MailingContent from "@/components/mail/MailingContent.vue";

export default {
  name: "ShowMailingContent",
  components: {MailingContent},
  props: {
    selectDetail:{
      default:()=>({})
    },
    showDialog:{
      default:false
    }
    },
  data() {
    return {
      title:'邮寄内容详情'
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    cancel() {
      this.$emit('submit', 'cancel')
    },
  },
}
</script>

<style scoped>

</style>